export default function ProgressBar({progress}:{progress:number}){
    const normalized = Math.max(0, Math.min(100, progress));
    return <div className="w-full h-2 rounded-full overflow-hidden mt-2 animate-pulse">
        <div className="h-full bg-green-500 rounded-full transition-all duration-300 ease-out" style={{width: `${normalized}%`}}></div>
    </div>
}